<template>
  <!-- <v-btn icon x-large class="ml-2" :to="{ name: 'Home' }">
    <v-avatar color="blue" size="54" class="border-radius-xl">
      <img
        v-if="profile.avatarPath"
        :src="profile.avatarPath"
        alt="profile Avatar"
        class="border-radius-n"
      />
      <img
        v-else
        src="@/assets/images/avatars/default-avatar.jpg"
        alt="profile Avatar"
        class="border-radius-xl"
      />
    </v-avatar>
  </v-btn> -->
  <div>
    <v-menu
      bottom
      offset-y
      nudge-bottom="6"
      transition="scale-transition"
      right
    >
      <template v-slot:activator="{ on }">
        <v-btn icon size="40" v-on="on" class="account-profile">
          <v-avatar color="blue" size="38">
            <!-- <img :src="profile.imageAddress" alt="profile Avatar" /> -->
            <img src="@/assets/images/avatars/default-avatar.jpg" />
          </v-avatar>
        </v-btn>
      </template>
      <v-card class="pt-2 px-0">
        <v-list-item-content class="justify-center pa-0">
          <ul class="pl-0">
            <li class="account-name text-center d-flex align-center pb-2 pt-0">
              <v-icon
                v-if="dashboard && dashboard.personGrade"
                :style="{
                  color: dashboard.personGrade.color,
                  fontSize: '1.2rem',
                  marginRight: '8px',
                }"
              >
                mdi-star
              </v-icon>
              <h6 class="pb-0">
                {{ currentUser.firstName }} {{ currentUser.lastName }} عزیز خوش
                آمدی
              </h6>
            </li>
            <li class="account-menu-item">
              <router-link :to="{ name: 'Profile' }" class="menu-item-link">
                <v-icon>mdi-account-edit-outline</v-icon>
                <h6>{{ label.menu.editProfile }}</h6>
              </router-link>
            </li>
            <li class="account-menu-item" @click="logOutCustomer">
              <div class="menu-item-link">
                <v-icon> mdi-exit-to-app</v-icon>
                <h6>{{ label.menu.logout }}</h6>
              </div>
            </li>
          </ul>
        </v-list-item-content>
      </v-card>
    </v-menu>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import label from "@/lang/StaticLabels.js";

export default {
  name: "TheAccountDropDown",
  data() {
    return {
      label,
    };
  },
  computed: {
    ...mapGetters({
      currentUser: "currentUser",
      dashboard: "operationX/dashboard",
    }),
  },
  methods: {
    logOutCustomer() {
      this.$store.dispatch("logout");
    },
  },
  mounted() {
    this.$store.dispatch("getCurrentUser");
    this.$store.dispatch("operationX/getDashboard");
  },
};
</script>
